import { IDiscount } from '@rbi-ctg/menu';
import { DiscountTypes } from 'enums/menu';
import { PosVendor } from 'generated/graphql-gateway';
import { selectors, useAppSelector } from 'state/global-state';
import { useIsLoyaltyEnabled } from 'state/loyalty/hooks/use-is-loyalty-enabled';
import { computeOtherDiscountAmount, getLoyaltyRewardsDiscount } from 'utils/cart/helper';

import { useCheckoutContext } from '../../hooks/use-checkout-context';

export const useTotalTipCalculations = () => {
  const { serverOrder, cartEntries } = useCheckoutContext();
  const { cart, delivery } = serverOrder || {};

  const loyaltyEnabled = useIsLoyaltyEnabled();
  const appliedLoyaltyRewards = useAppSelector(selectors.loyalty.selectAppliedLoyaltyRewards);
  const isPricingRewardApplication = useAppSelector(
    selectors.loyalty.selectIsPricingRewardApplication
  );

  const deliveryFee = delivery ? delivery.feeCents : null;
  const deliveryFeeDiscount = delivery ? delivery.feeDiscountCents : null;
  const allDiscounts = cart?.discounts || [];

  const posRewardDiscount = () => {
    return allDiscounts.find(
      (discount: IDiscount) => discount.name === DiscountTypes.REWARDS_DISCOUNTS
    )?.value;
  };
  const otherDiscountAmount = computeOtherDiscountAmount(allDiscounts);

  // delivery.tipCents is null until the user advances to PAYMENT_REQUESTED
  // at the same time, totalCents increases by the tip amount
  // we needed to do this to render the correct grand total/tip as user advances
  const serverOrderTip = Number(delivery?.tipCents || 0);

  // currently not all POS vendors return discount amount in cart response when offers are applied
  // for loyalty rewards with loyaltyEnabled = true, the discount amount is calculated in the FE
  // otherwise it is returned from the POS system
  const rewardDiscountAmount =
    loyaltyEnabled && !isPricingRewardApplication
      ? getLoyaltyRewardsDiscount({
          cartEntries,
          loyaltyEnabled,
          appliedLoyaltyRewards,
        })
      : posRewardDiscount();

  let additionalDiscountAmount = otherDiscountAmount;

  // subtract loyalty reward amount for posVendors that return "otherDiscountAmount" e.g. carrols
  // Carrols was determined to be the only POS vendor requiring this logic
  if (
    loyaltyEnabled &&
    rewardDiscountAmount &&
    additionalDiscountAmount &&
    additionalDiscountAmount >= rewardDiscountAmount &&
    serverOrder?.cart.posVendor === PosVendor.CARROLS
  ) {
    additionalDiscountAmount -= rewardDiscountAmount;
  }

  return {
    rewardDiscountAmount,
    serverOrderTip,
    additionalDiscountAmount,
    deliveryFee,
    deliveryFeeDiscount,
  };
};
